import { Input } from '@/components/Input';
import { selectLoanTerm } from '@/context/borrower';
import { useAppSelector } from '@/context/storeHooks';

export interface IProps {
    baseId: string;
}

export const testId = 'LoanTermDisabled';

export function LoanTermDisabled({ baseId }: IProps): JSX.Element {
    // ***** Redux *****
    const loanTerm = useAppSelector(selectLoanTerm);

    // ***** Render *****
    return (
        <div data-testid={testId} className='w-full'>
            <Input
                title={'Loan Term (Years)'}
                placeholder=''
                id={`${baseId}-input-LoanAmount`}
                value={loanTerm.toLocaleString()}
                showNumpad={true}
                disabled
                tooltipContent='This is a set loan term.'
            />
        </div>
    );
}
